<div class="page">

  <div class="page-header">
    <div>
      <h1>Banners</h1>
      <p>Manage promotional banners displayed in the app</p>
    </div>
    <button class="btn-primary" (click)="goToNew()">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
        <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
      </svg>
      New Banner
    </button>
  </div>

  <div class="loading-state" *ngIf="isLoading">
    <div class="spinner-lg"></div>
    <p>Loading banners...</p>
  </div>

  <div class="banners-grid" *ngIf="!isLoading">

    <div class="banner-card" *ngFor="let item of banners" (click)="goToDetail(item.id)">

      <!-- Image Preview -->
      <div class="banner-preview">
        <img *ngIf="item.image_url" [src]="item.image_url" [alt]="'banner-' + item.id" class="preview-img" />
        <div *ngIf="!item.image_url" class="preview-placeholder">
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
            <rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/>
            <polyline points="21 15 16 10 5 21"/>
          </svg>
        </div>
      </div>

      <!-- Card Body -->
      <div class="banner-body">
        <div class="banner-top">
          <span class="badge" [class.badge-active]="item.is_active" [class.badge-inactive]="!item.is_active">
            {{ item.is_active ? 'Active' : 'Inactive' }}
          </span>
          <span class="chip">{{ item.slot === 'explore_top' ? 'Top rail' : 'In-feed' }}</span>
          <span class="chip chip-gold" *ngIf="item.kind === 'sponsored'">Sponsored</span>
          <span class="chip" *ngIf="item.media_type === 'video'">Video</span>
          <span class="banner-date">{{ item.created_at | date:'mediumDate' }}</span>
        </div>

        <div class="banner-meta">
          <div class="meta-row" *ngIf="item.link">
            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/>
              <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/>
            </svg>
            <span class="meta-text" [title]="item.link">{{ item.link }}</span>
          </div>
          <div class="meta-row" *ngIf="item.phone">
            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.62 3.38 2 2 0 0 1 3.61 1h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.6a16 16 0 0 0 6.09 6.09l.96-.96a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/>
            </svg>
            <span class="meta-text">{{ item.phone }}</span>
          </div>
          <div class="meta-row" *ngIf="item.caption_en || item.caption_ar">
            <span class="meta-text" [title]="item.caption_en || item.caption_ar">{{ item.caption_en || item.caption_ar }}</span>
          </div>
          <p class="no-meta" *ngIf="!item.link && !item.phone && !item.caption_en && !item.caption_ar">No caption, link or phone</p>
        </div>
      </div>

    </div>

    <div class="empty-state" *ngIf="banners.length === 0">
      <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">
        <rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/>
        <polyline points="21 15 16 10 5 21"/>
      </svg>
      <p>No banners yet.</p>
      <button class="btn-primary" (click)="goToNew()">Create First Banner</button>
    </div>

  </div>

</div>
